export default __webpack_public_path__ + "static/media/journeytray-smallbluetree.3a9219ef.svg";